import { z } from "zod";
import { withAffiliationMax } from "../../utils/affiliation";

export interface affiliationTypes{
    disabled_date?: string | null;
    id: number;
    creation_date: string;
    modified_by: number | null;
    name: string;
    type: string;
    country: string;
    logo_url: string;
    flag_disabled: boolean;
    modified_date?: string | null;
    created_by?: number;
    disabled_by?: number | null;
    city: string;
    state: string;
    zipcode: string;

}

export interface createAffiliationTypes{
    slug?: string;
    name: string;
    city: string;
    type: string;
    state: string;
    country: string;
    zipcode: string;
    logo_url: string;

}


export const affiliationSchema = z.object({
    name: withAffiliationMax(z.string().min(1, "El nombre es obligatorio")),
    city: z.string().min(1, "La ciudad es obligatoria"),
    type: z.string().min(1, "El tipo es obligatorio"),
    state: z.string().min(1, "El estado es obligatorio"),
    country: z.string().min(1, "El país es obligatorio"),
    zipcode: z.string().min(1, "El código postal es obligatorio"),
    logo_url: z.string().min(1, "La URL del logo es obligatoria"),
});